// eslint-disable-next-line
import React from 'react';
import Link from '@material-ui/core/Link';
import Button, { ButtonProps } from '@material-ui/core/Button';

const LinkButton = (props: ButtonProps) => (
  <Button {...props} component={Link as any} />
);

export default LinkButton;
